export enum REQUEST_GRID_LOCATIONS {
  REQUESTS_INDEX = 'requests_index_page',
  CONTROLS_SHOW = 'controls_show_page',
  EVIDENCE_SHOW = 'evidence_show_page',
}
